module.exports = __webpack_public_path__ + "static/bookimageog-099fd9b137980fa3340bb99d6d23fb75.jpg";